import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';

document.addEventListener('DOMContentLoaded', function() {
	let calendarEl = document.getElementById('events-calendar');
	let calendarToday = document.getElementById('events-today');
	let calendarDay1 = document.getElementById('events-day1');
	let calendarDay2 = document.getElementById('events-day2');
	let calendarDay3 = document.getElementById('events-day3');

	let popOverSettings = {
		html: true,
		placement: 'top',
		container: 'body',
		trigger: 'hover',
		selector: '.fc-day-grid-event',
		template: '<div class="popover popover--calendar" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
		content: function () {
			return $(this).find('.fc-content').html();
		}
	}
	$('body').popover(popOverSettings);

	let baseCalenderStyles = {
		eventTimeFormat: {
			hour: 'numeric',
			minute: '2-digit',
			omitZeroMinute: true,
			meridiem: 'short'
		},
		events: {
			url: '/events/calendar.json',
			extraParams: function() {
				return {
					cachebuster: new Date().valueOf()
				};
			}
		},
		columnHeaderFormat: {
			weekday: 'long'
		},
		buttonIcons: false
	};

	let dayOptions = {
		plugins: [listPlugin],
		defaultView: 'listDay',
		height: 400,
		header: {
			left: 'title',
			center: '',
			right: ''
		},
		...baseCalenderStyles
	};

	if (calendarEl) {
		let filter = calendarEl.getAttribute('data-category');
		let calendar = new Calendar(calendarEl, {
			plugins: [dayGridPlugin],
			header: {
				left: 'prev next today',
				center: 'title',
				right: 'dayGridMonth dayGridWeek dayGridDay'
			},
			height: 'auto',
			...baseCalenderStyles
		});

		calendar.render();
	}

	if (calendarToday) {
		let calendarT = new Calendar(calendarToday, dayOptions);
		calendarT.render();
	}
	if (calendarDay1) {
		let dD = new Date();
		dD.setTime(dD.getTime() + 24 * 60 * 60 * 1000);
		dayOptions['defaultDate'] = dD;
		let calendard1 = new Calendar(calendarDay1, dayOptions);
		calendard1.render();
	}
	if (calendarDay2) {
		let dD = new Date();
		dD.setTime(dD.getTime() + 24 * 2 * 60 * 60 * 1000);
		dayOptions['defaultDate'] = dD;
		let calendard2 = new Calendar(calendarDay2, dayOptions);
		calendard2.render();
	}
	if (calendarDay3) {
		let dD = new Date();
		dD.setTime(dD.getTime() + 24 * 3 * 60 * 60 * 1000);
		dayOptions['defaultDate'] = dD;
		let calendard3 = new Calendar(calendarDay3, dayOptions);
		calendard3.render();
	}
});
